/**
 * Status string aliases aligned with `ReusableStatusBar` — maps API / business-status
 * variants to canonical underscore keys that match `statusBarData` step keys and labels.
 */

/**
 * Lowercase; NBSP → space; runs of whitespace, ASCII hyphen, en dash, em dash → single underscore.
 * So API labels like "Artwork In-Design" and "… – TJ" normalize like space-separated titles.
 */
export function normalizeStatusCharactersToSlugKey(status: string): string {
  if (!status || typeof status !== "string") return "";
  return status
    .toLowerCase()
    .replace(/\u00a0/g, " ")
    .trim()
    .replace(/[\s\u002D\u2013\u2014]+/g, "_")
    .replace(/_+/g, "_");
}

export const STATUS_BAR_STATUS_ALIASES: Record<string, string> = {
  // Tasting Panel variations
  testing_panel_approved: "tasting_panel_approved",
  tasting_panel_approved: "tasting_panel_approved",

  // Business Review variations
  awaiting_business_review: "awaiting_business_review",
  business_review_pending: "awaiting_business_review",

  // Vendor Assessment variations
  vendor_assessment_in_progress: "vendor_assessment",
  vendor_assessment_pending: "vendor_assessment",

  // Ready For Orders variations
  prepare_for_launch: "ready_for_orders",
};

/**
 * Same normalization as the status bar: character normalization, then full status-bar alias map.
 */
export function normalizeActiveProjectStatusForStepLookup(status: string): string {
  if (!status) return "";
  const normalized = normalizeStatusCharactersToSlugKey(status);
  return STATUS_BAR_STATUS_ALIASES[normalized] ?? normalized;
}
